
export const PLUS_MENU_LEVEL = "PLUS_MENU_LEVEL";
export const MINUS_MENU_LEVEL = "MINUS_MENU_LEVEL";

export const SHOW_START_SCREEN = "SHOW_START_SCREEN";
export const SWITCH_MENU = "SWITCH_MENU";

export const PLUS_INDEX_FIRST_LEVEL = "PLUS_INDEX_FIRST_LEVEL";
export const MINUS_INDEX_FIRST_LEVEL = "MINUS_INDEX_FIRST_LEVEL";

export const PLUS_INDEX_SECOND_LEVEL = "PLUS_INDEX_SECOND_LEVEL";
export const MINUS_INDEX_SECOND_LEVEL = "MINUS_INDEX_SECOND_LEVEL";

export const PLUS_INDEX_THIRD_LEVEL = "PLUS_INDEX_THIRD_LEVEL";
export const MINUS_INDEX_THIRD_LEVEL = "MINUS_INDEX_THIRD_LEVEL";

export const PLUS_INDEX_FOURTH_LEVEL = "PLUS_INDEX_FOURTH_LEVEL";
export const MINUS_INDEX_FOURTH_LEVEL = "MINUS_INDEX_FOURTH_LEVEL";

export const PLUS_INDEX_FOURTH_LEVEL_NEXT = "PLUS_INDEX_FOURTH_LEVEL_NEXT";
export const MINUS_INDEX_FOURTH_LEVEL_PREV = "MINUS_INDEX_FOURTH_LEVEL_PREV";

export const PLUS_INDEX_FIFTH_LEVEL = "PLUS_INDEX_FIFTH_LEVEL";
export const MINUS_INDEX_FIFTH_LEVEL = "MINUS_INDEX_FIFTH_LEVEL";

export const PLUS_INDEX_FIFTH_LEVEL_NEXT = "PLUS_INDEX_FIFTH_LEVEL_NEXT";
export const MINUS_INDEX_FIFTH_LEVEL_PREV = "MINUS_INDEX_FIFTH_LEVEL_PREV";

export const PLUS_INDEX_SIXTH_LEVEL_NEXT = "PLUS_INDEX_SIXTH_LEVEL_NEXT";
export const MINUS_INDEX_SIXTH_LEVEL_PREV = "MINUS_INDEX_SIXTH_LEVEL_PREV";

export function showStartMenu() {
    return {
        type: SHOW_START_SCREEN
    }
}

export function switchStartMenu() {
    return {
        type: SWITCH_MENU
    }
}

export function plusMenuLevel() {
    return {
        type: PLUS_MENU_LEVEL
    }
}

export function minusMenuLevel() {
    return {
        type: MINUS_MENU_LEVEL
    }
}

export function plusIndex(menuLevel) {
    return {
        type: menuLevel
    }
}

export function minusIndex(menuLevel) {
    return {
        type: menuLevel
    }
}

